"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = getImageUrl;
const RIOT_CDN_BASE_URL = `https://assetcdn.rgpub.io/public/live/riot-shared/player-experiences/riot-glyphs/`;
function getImageUrl({ cdnSuffix, image, version }) {
    let base = RIOT_CDN_BASE_URL;
    if (!base.endsWith('/')) {
        base += '/';
    }
    // If suffix is provided and not already in the path, add it
    if (cdnSuffix && !base.endsWith(`${cdnSuffix}/`)) {
        base += `${cdnSuffix}/`;
    }
    // If version is provided, append it to the base URL
    if (version && !base.endsWith(`${version}/`)) {
        base += `${version}/`;
    }
    return base + image.replace(/^\/+/, '');
}
